// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2079":"DashboardPageView","4956":"ProjectOptimizationView"}[chunkId] + "." + {"2079":"4297ae11","4956":"21cc379d"}[chunkId] + ".chunk.css";
};